import React, { useState, useContext } from "react";
import NavBarComponent from "./NavBarComponent";
import { ReactNotifications } from "react-notifications-component";
import "react-notifications-component/dist/theme.css";
import PermissionContext from "../Store/permission-context";
import classes from "./MainContainer.module.css";
import { Container } from "react-bootstrap";
import { Link, Switch, Route, Redirect } from "react-router-dom";
import Headroom from "react-headroom";
import HomeComponent from "./pages/HomeComponent";
import NewRegistration from "./pages/NewRegistration";
import ViewUser from "./pages/ViewUser";
import ChangePassword from "./pages/ChangePassword";
import SupplyIn from "./pages/SupplyIn";
import ChangePrice from "./pages/ChangePrice";
import Sales from "./pages/Sales";
import GetReport from "./pages/GetReport";
import GetHistory from "./pages/GetHistory";
import GetSupplyReport from "./pages/GetSupplyReport";
import GetMyReport from "./pages/GetMyReport";
import CashFlow from "./pages/CashFlow";
// import RestoreBackup from "./pages/RestoreBackup";
import Inventory from "./pages/Inventory";
import GoodsReport from "./pages/GoodsReport";
import BackUp from "./pages/BackUp";
import ViewDebts from "./pages/ViewDebts";
import GetCustomerAndExpenditureReport from "./pages/GetCustomerAndExpenditureReport";
import Admin from "./pages/Admin";
import UpdateServer from "./pages/UpdateServer";
import Cookies from "universal-cookie";
import ExpiredPage from "./pages/ExpiredPage";

const MainContainer = () => {
  const cookies = new Cookies();
  const PCtx = useContext(PermissionContext);

  const [RoutePage, setRoutePage] = useState([
    { path: "/", component: HomeComponent },
    { path: PCtx.RealPath + "/addnewuser", component: NewRegistration },
    { path: PCtx.RealPath + "/viewusers", component: ViewUser },
    { path: PCtx.RealPath + "/changepassword", component: ChangePassword },
    { path: PCtx.RealPath + "/supplyin", component: SupplyIn },
    { path: PCtx.RealPath + "/changeprice", component: ChangePrice },
    { path: PCtx.RealPath + "/sales", component: Sales },
    { path: PCtx.RealPath + "/getreport", component: GetReport },
    { path: PCtx.RealPath + "/getsupplyreport", component: GetSupplyReport },
    { path: PCtx.RealPath + "/myreport", component: GetMyReport },
    { path: PCtx.RealPath + "/goodssummary", component: GoodsReport },
    { path: PCtx.RealPath + "/viewdebts", component: ViewDebts },
    { path: PCtx.RealPath + "/expireditems", component: ExpiredPage },
    { path: PCtx.RealPath + "/cashflow", component: CashFlow },
    { path: PCtx.RealPath + "/updateonline", component: UpdateServer },
    // { path: PCtx.RealPath+"/restorebackup", component: RestoreBackup },
    {
      path: PCtx.RealPath + "/customersreports",
      component: GetCustomerAndExpenditureReport,
    },
    { path: PCtx.RealPath + "/gethistory", component: GetHistory },
    { path: PCtx.RealPath + "/inventory", component: Inventory },
    { path: PCtx.RealPath + "/backup", component: BackUp },
    { path: PCtx.RealPath + "/admin", component: Admin },
  ]);

  return (
    <Container fluid className={classes.AllElements} style={{ padding: "0px" }}>
      <ReactNotifications />

      <NavBarComponent />

      {PCtx.logged ? (
        <Switch>
          {RoutePage.map((page, index) => (
            <Route exact {...page} key={index} />
          ))}
        </Switch>
      ) : (
        <Switch>
          <Route path="/" component={HomeComponent} />
        </Switch>
      )}
    </Container>
  );
};

export default MainContainer;
